import { render, staticRenderFns } from "./ScanGaugeKit.vue?vue&type=template&id=5983ee42"
import script from "./ScanGaugeKit.vue?vue&type=script&lang=js"
export * from "./ScanGaugeKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports